export default {
  common: {
    menu: 'Menu',
    error: 'Error',
    no: 'No',
    search: 'Search',
    selected: 'Selected',
    yes: 'Yes',
  },
  actions: {
    clear: 'Clear',
  },
};
